import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TabsModule } from 'primeng/tabs';

@Component({
  selector: 'app-business-view',
  imports: [RouterModule, TabsModule],
  templateUrl: './business-view.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BusinessViewComponent { 
  
  tabs: { route: string; label:string}[] = [];
    
  private route = inject(Router);

  public url = this.route.url;

  ngOnInit(): void {
    this.tabs = [
      {
        route: '/app/business/reporting',
        label: 'Reporte'
      },
      {
        route: '/app/business/detail',
        label: 'Detalle'
      }
    ]
  }
}
